/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import { useState, useEffect, useMemo } from 'react';
import Router from 'next/router';

// Component
import ModalCheckout from 'components/CourseDescription/ModalCheckout';
import PriceContainer from 'components/PriceContainer';
import moment from 'moment';

//Services
import { getCourseDetail } from 'services/course-description';
import { useImageHandler } from 'utils/custom_hooks';
import { cancelEventBubble } from 'utils/cancel_event_bubble';
import { getProductDetail } from 'services/products';
import { synchronizedSingleCartData } from 'utils/manipulate_array';
import { generateCoverImageUrl } from 'utils/generate_cover_image_url';
import useLandingCardItemData from '../../hooks/useLandingCardItemData';
import { getBundleDetails } from '../../services/bundles';
import { month } from 'utils/month';
import { truncateText } from 'utils/helper';
import { getClassNameByLang } from 'utils/getClassByLang';
import Button from 'components/Button';
import { BUTTON_TYPE } from 'constants/button';
import { SubHeading, TextBody } from 'components/Typography/General';
import { FONT_TYPES } from 'variables/font_groups';
import { isMobile } from 'react-device-detect';
import { getDirectionByLanguage } from 'utils/get_direction';
import { trackAddToCart, trackCtaClick, trackRemoveFromCart } from 'lib/analytics';

export default function Card(props) {
  const { isLoading, setIsLoading, isProduct, item, itemType, activeTabItemName, language, onTrackingClick } = props;
  const dateFrom = item?.dateFrom;
  const dateTo = item?.dateTo;
  const [cart, setCart] = useState([]);
  const [openModalCheckout, setOpenModalCheckout] = useState(false);
  const { title, image, price, discount, slug, category, user } = useLandingCardItemData({ item, itemType });
  const memoizedOptionList = useMemo(() => [user.picture, user.companyLogo], [user.picture, user.companyLogo]);
  const { currentImage, handleImageToDefault, handleIsImageAvailable } = useImageHandler({
    optionList: memoizedOptionList,
    data: user,
  });
  const classNameByLang = getClassNameByLang(language);

  const addToCart = async () => {
    setIsLoading(true);
    let data;
    switch (itemType) {
      case 'products':
        data = await getProductDetail(slug);
        break;
      case 'bundles':
        data = await getBundleDetails(slug);
        break;
      default:
        data = await getCourseDetail(slug);
        break;
    }

    if (!data) {
      return;
    }

    const newCart = synchronizedSingleCartData({ item: data, isProduct: isProduct });

    // data.name = data.courseTitle;
    let list_cart = [...cart];
    let new_data = [];
    let openModal = false;

    if (list_cart.filter((cart) => cart.itemId == newCart.itemId).length !== 0) {
      new_data = list_cart.filter((cart) => cart.itemId !== newCart.itemId);
      trackCtaClick({
        page_type: 'landing_page',
        cta_label: 'remove_from_cart',
        location: itemType + '_landing_card',
        course_id: data.courseId || data.productId || data._id,
      });

      trackRemoveFromCart({
        page_type: 'landing_page',
        currency: 'USD',
        value: price * -1,
        items: [
          {
            item_id: data.courseId || data.productId || data._id,
            item_name: data.courseTitle || data.title,
            item_category: data.categoryName || 'unknown',
            item_variant: itemType === 'products' ? 'product' : 'course',
            price,
            quantity: 0,
          },
        ],
        course_id: data.courseId || data.productId || data._id,
      });
    } else {
      list_cart.forEach((list) => {
        new_data.push(list);
      });
      new_data.push(newCart);
      openModal = true;
      trackCtaClick({
        page_type: 'landing_page',
        cta_label: 'add_to_cart',
        location: itemType + '_landing_card',
        course_id: data.courseId || data.productId || data._id,
      });

      trackAddToCart({
        page_type: 'landing_page',
        currency: 'USD',
        value: price,
        items: [
          {
            item_id: data.courseId || data.productId || data._id,
            item_name: data.courseTitle || data.title,
            item_category: data.categoryName || 'unknown',
            item_variant: itemType === 'products' ? 'product' : 'course',
            price,
            quantity: 1,
          },
        ],
        course_id: data.courseId || data.productId || data._id,
      });
    }

    const synchronizedCartData = new_data.map((item) => {
      return synchronizedSingleCartData({ item: item, isProduct: item.isProduct || false });
    });

    setCart(synchronizedCartData);

    localStorage.setItem('cart', JSON.stringify(synchronizedCartData));
    localStorage.setItem('slug', slug);

    if (openModal) {
      setOpenModalCheckout(true);
    } else {
      Router.reload(window.location.href);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    const currentCart = localStorage.getItem('cart');

    if (currentCart) {
      const newCart = JSON.parse(currentCart).map((cartItem) => {
        return synchronizedSingleCartData({ item: cartItem, isProduct: cartItem.isProduct || false });
      });

      setCart(newCart);
    }
  }, []);

  return (
    <div
      className="landing-card-wrapper"
      onClick={() => {
        onTrackingClick && onTrackingClick();
        Router.push(`/${activeTabItemName}/${slug}`);
      }}
    >
      <div className="landing-card-content-container">
        <div className="landing-card-left-container">
          <div className="landing-card-image-container">
            <img className="landing-card-image" src={generateCoverImageUrl(image)} alt={title} />
          </div>
        </div>
        <TextBody variety={5} className="landing-card-category-text">
          {category}
        </TextBody>
        <div className="landing-card-right-container">
          <div onClick={() => {
            trackCtaClick({
              page_type: 'landing_page',
              cta_label: 'provider_click',
              provider_id: user.courseOrganizer,
              location: 'homepage_landing_card',
            })
          }}>
            <SubHeading
              variety={4}
              dir={getDirectionByLanguage(language)}
              className={`landing-card-title ${classNameByLang}`}
              style={{ textWrap: 'break-word' }}
            >
              {title}
              {/* {truncateText(title, 45, true)} */}
            </SubHeading>
            <div className="landing-card-user-picture-container">
              {!handleIsImageAvailable(user.picture) ? (
                <>
                  <div className="user-picture-container company-logo">
                    <img
                      className="landing-card-user-picture"
                      src={currentImage}
                      onError={handleImageToDefault}
                      alt={user.name}
                    />
                  </div>
                  <TextBody variety={4} className="landing-card-user-name name-in-logo">
                    {user.name}
                  </TextBody>
                </>
              ) : (
                <div className="user-picture-container course-logo">
                  <img
                    className="landing-card-user-picture"
                    src={currentImage}
                    onError={handleImageToDefault}
                    alt={user.name}
                  />
                </div>
              )}
            </div>
          </div>

          <div>
            <TextBody variety={5} className="landing-card-user-name mt-4">
              By: {user.name}
            </TextBody>

            {(dateFrom ?? dateTo) && (
              <div className="informations">
                <>
                  <div className="light font-size-14 text-secondary">Course Schedule:</div>
                  <p
                    dir={language === 'Arabic' ? 'rtl' : 'ltr'}
                    className="bold font-size-14 text-secondary d-none d-lg-flex"
                  >
                    {dateFrom && moment(dateFrom).format('D MMMM YYYY')}
                    {dateFrom && dateTo && ' - '}
                    {dateTo && moment(dateTo).format('D MMMM YYYY')}
                  </p>
                </>
              </div>
            )}
            <PriceContainer
              className="landing-card-price"
              variableDiscount={[discount]}
              variablePrice={[price]}
              isMedium
              courseOrganizer={user.courseOrganizer}
            />
          </div>
        </div>
      </div>
      <div className="landing-card__information">
        <Button
          className="show landing-card-button p-0 mt-0 fw-semibold"
          variety={5}
          fontType={FONT_TYPES.subHeading}
          type={BUTTON_TYPE.secondary}
        >
          More Information
        </Button>
        <div className="hidden d-flex gap-4">
          <Button
            type={BUTTON_TYPE.primary}
            variety={5}
            fontType={FONT_TYPES.subHeading}
            onClick={(e) => {
              cancelEventBubble(e);
              onTrackingClick && onTrackingClick();
              Router.push(`/${activeTabItemName}/${slug}`);
            }}
            className="landing-card-button p-0 mt-0"
          >
            More Information
          </Button>
          <img
            role="button"
            style={{
              height: '5rem',
              width: '5rem',
              border: '1px solid #066bfb',
              borderRadius: '.4rem',
            }}
            src="/landing/card/cart.gif"
            onClick={(e) => {
              cancelEventBubble(e);
              addToCart();
            }}
          />
        </div>
      </div>

      {openModalCheckout && (
        <ModalCheckout
          setOpen={setOpenModalCheckout}
          open={openModalCheckout}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          language={language}
        />
      )}
    </div>
  );
}
